import {mapActions} from "vuex";

export default {
    data() {
        return {

        }
    },
    methods: {
        ...mapActions('modal', ['modalType_reviewsOpen']),
    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/reviews-item/component.js